module.exports = __webpack_public_path__ + "static/media/OpenSeas_web_3.e4af9328.jpg";